import React, { ReactNode } from 'react';
import { useSurvey } from './SurveyContext';
import { cross, thanksPopUpTick } from '../../../../assets/assetsSVG';


interface ThankYouProps {
  className ? :string
  children ?: ReactNode
}

export const ThankYou: React.FC<ThankYouProps> = ({ 
  className,
  children 
}) => {
  const { 
    handleThanks, 
    iconColor, 
    themeManager ,
    thankYouHeading = "Feedback Submitted",
    thankYouDescription = "Thanks for submitting your feedback with us. We appreciate your review and will assure you to surely consider them.",
  } = useSurvey();

  return (
    <div className={`q-survey-thank-you ${className || ''}`}>
      <div
        className="q_submit_cross_icon"
        onClick={handleThanks}
        style={{ cursor: "pointer" }}
      >
        {cross(iconColor)}
      </div>
      <div className="q-fw-thanks">
        <div>
          <div className="q-svg-thanks">{thanksPopUpTick(themeManager.getThanksPopUbIconBackgroundStyle())}</div>
          <div className="q_fw_submit_box">
            <div className="q_feedback_text_submitted">
              <div
                className="q_feedback_text_cont"
                style={themeManager.getHeaderStyles().heading}
              >
                {thankYouHeading}
              </div>
              <div
                className="q_fw_submit_desc"
                style={themeManager.getHeaderStyles().description}
              >
                {thankYouDescription}
              </div>
            </div>
            <div
              onClick={handleThanks}
              className="q_fw_submit_back"
              style={themeManager.getButtonStyles().secondary}
            >
              Go to home!
            </div>
          </div>
        </div>
      </div>
      {children} 
    </div>
  );
};